import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { useSite, FALLBACK_SETTINGS } from "@/lib/content";

const SECTIONS = [
  {
    title: "1. Acceptance of Terms",
    body: "By accessing or using the LogiTech Nexus website, you agree to these Terms of Use. If you do not agree, please do not use this website. These terms govern use of the website only; software development engagements are governed by separate written agreements.",
  },
  {
    title: "2. Website Content",
    body: "Content on this website is provided for general informational purposes. Descriptions of services and capabilities represent the types of solutions LogiTech Nexus designs and builds; specific deliverables, timelines and pricing are defined in individual project agreements.",
  },
  {
    title: "3. Intellectual Property",
    body: "All content on this website — including text, design, graphics, and the LogiTech Nexus name and brand mark — is the property of LogiTech Nexus and may not be reproduced without written permission. Intellectual property terms for client work are defined in individual project agreements.",
  },
  {
    title: "4. Acceptable Use",
    body: "You agree not to misuse this website, including attempting unauthorized access to systems or data, submitting false or malicious information through forms, interfering with site operation, or using automated means to abuse site functionality.",
  },
  {
    title: "5. No Professional Advice",
    body: "Information on this website does not constitute professional, legal, or technical advice. Consult with us directly regarding your specific requirements before making technology decisions.",
  },
  {
    title: "6. Limitation of Liability",
    body: "To the maximum extent permitted by law, LogiTech Nexus is not liable for any indirect, incidental, or consequential damages arising from use of this website. The website is provided \"as is\" without warranties of any kind.",
  },
  {
    title: "7. Third-Party Links",
    body: "This website may contain links to third-party websites. We are not responsible for the content or practices of third-party sites.",
  },
  {
    title: "8. Governing Law",
    body: "These terms are governed by the laws of the State of Washington, United States, without regard to conflict-of-law principles.",
  },
  {
    title: "9. Changes to These Terms",
    body: "We may update these Terms of Use from time to time. Continued use of the website after changes are posted constitutes acceptance of the updated terms.",
  },
];

export default function Terms() {
  const { data } = useSite();
  const s = { ...FALLBACK_SETTINGS, ...(data?.settings || {}) };
  const seo = data?.settings?.seo?.["/terms"];

  return (
    <>
      <Seo
        title={seo?.title || "Terms of Use | LogiTech Nexus"}
        siteName="LogiTech Nexus"
        description={seo?.description || "Terms governing the use of the LogiTech Nexus website."}
      />
      <PageHero eyebrow="Legal" title="Terms of Use" subtitle="Effective date: January 1, 2026" testid="terms-hero" />
      <section className="bg-void pb-28" data-testid="terms-content">
        <div className="mx-auto max-w-3xl space-y-10 px-6 lg:px-10">
          {SECTIONS.map((sec) => (
            <div key={sec.title}>
              <h2 className="font-display text-xl font-semibold text-white">{sec.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{sec.body}</p>
            </div>
          ))}
          <div className="rounded-xl border border-slate-800/70 bg-navy/50 p-6">
            <h2 className="font-display text-xl font-semibold text-white">Questions</h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">
              {s.companyName} · {s.addressLine1}, {s.addressLine2}, {s.addressCountry}
              <br />
              <a href={`mailto:${s.email}`} className="text-blue-400 transition-colors hover:text-blue-300" data-testid="terms-email-link">
                {s.email}
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
